import { createSlice } from "@reduxjs/toolkit";


export const selectedCreneauxSlice = createSlice({
    name: 'selectedCreneaux',
    initialState:{},
    reducers: { // 
       
        addCreneau: (currentState, action) => {
           
            let newList = currentState.filter((ligne)=>ligne.creneau.id_creneau!==action.payload.creneau.id_creneau);
            newList.push(action.payload);
            return newList;

        },
        removeCreneau: (currentState, action) => {
            
            let newList = currentState.filter((ligne)=>ligne.creneau.id_creneau!==action.payload);
            return newList;
        },
        modifyCreneau: (currentState, action) => {
            
            let newList = currentState.filter((ligne)=>ligne.creneau.id_creneau!==action.payload.creneau.id_creneau);
            newList.push(action.payload);
            return newList;
        },
        initCreneaux: (currentState, action) => {
            
            return action.payload;
        },
    }
});

